<div class="content-footer">
  <div class="row">
      <div class="col-8">
          <p>Derechos Reservados doHealth® {{year}}</p>
          <a routerLink="aviso-de-privacidad" class="g">Aviso de Privacidad</a>
          <a routerLink="politicas-de-uso-de-cookies" class="b">Políticas de Uso de cookies</a>
      </div>
      <div class="col-4">
          <button><a href={{icons.linkfb}} target="_blank"><img  src={{icons.fb}}></a></button>
          <button><a href={{icons.linkln}} target="_blank"><img  src={{icons.ln}}></a></button>
          <button><a href={{icons.linktw}} target="_blank"><img  src={{icons.tw}}></a></button>
      </div>

</div>
